module.exports = __webpack_public_path__ + "img/new-index-apply-dl.177a5fc0.png";